var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71933 7.72275C0.710938 9.73114 0.710938 12.9636 0.710938 19.4285V20.5714C0.710938 27.0363 0.710938 30.2688 2.71933 32.2772C4.72773 34.2855 7.96019 34.2855 14.4251 34.2855H15.568C22.0329 34.2855 25.2653 34.2855 27.2737 32.2772C29.2821 30.2688 29.2821 27.0363 29.2821 20.5714V19.4285C29.2821 12.9636 29.2821 9.73114 27.2737 7.72275C25.2653 5.71436 22.0329 5.71436 15.568 5.71436H14.4251C7.96019 5.71436 4.72773 5.71436 2.71933 7.72275ZM5.4728 14.4643C5.62576 21.8964 9.52954 26.3689 15.9639 26.3689H16.3372V22.1171C18.6806 22.355 20.4282 24.1069 21.1416 26.3689H24.5203C23.6037 22.9851 21.2272 21.1142 19.7501 20.3994C21.226 19.5154 23.3149 17.3724 23.8069 14.4643H20.7329C20.088 16.8292 18.1692 18.9722 16.336 19.1758V14.4643H13.213V22.7129C11.3125 22.2372 8.83325 19.9237 8.73166 14.4643H5.4728Z",
    fill: "#2F2F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.959b8bdb47f3e05daa4d9e817c25104b.svg";
export { ForwardRef as ReactComponent };